var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 67,
    viewBox: "0 0 76 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006186"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624664",
    x: 1.05566,
    y: 1,
    width: 73.8882,
    height: 64.4022,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624665",
    x: 1.50098,
    y: 10,
    width: 11,
    height: 55,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624667",
    x: 17.8386,
    y: 17.0533,
    width: 22.0799,
    height: 14.783,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624673",
    x: 5.16504,
    y: 4.10791,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624674",
    x: 10.2744,
    y: 4.10791,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624675",
    x: 15.376,
    y: 4.10791,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624670",
    x: 44.1077,
    y: 17.0533,
    width: 24.9987,
    height: 33.755,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624668",
    x: 17.8386,
    y: 36.0254,
    width: 22.0799,
    height: 14.783,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624669",
    x: 17.8386,
    y: 54.2677,
    width: 22.0799,
    height: 11.1345,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624672",
    x: 44.1077,
    y: 54.2677,
    width: 24.9987,
    height: 11.1345,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624666",
    x: 12.501,
    y: 10,
    width: 62,
    height: 55,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.645c2f6e881fd0423f14da95e21e53b9.svg";
export { ForwardRef as ReactComponent };